import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type { CompetencyAssessment } from 'modules/reviews/store/models/QuestionGroup'

import AssessmentItem from './AssessmentItem'

interface Props {
  assessments: CompetencyAssessment[]
  readonly: boolean
  loading?: boolean
  onUpdate?: (assessment: CompetencyAssessment) => void
  accessCompetencies: boolean
}

const ReviewCompetencyAssessment: React.FC<Props> = ({
  assessments,
  readonly,
  loading,
  onUpdate,
  accessCompetencies,
}) => {
  if (!assessments.length) {
    return null
  }

  return (
    <Box
      border={{
        top: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      paddingBottom="s40"
    >
      <Box gap="s32" paddingTop="s24" paddingX="s24">
        <Box gap="s8">
          <Text size="300" color="grey1000" weight="medium">
            {i18n.t('reviews.competencies_assessment.title')}
          </Text>
          <Text size="200">{i18n.t('reviews.competencies_assessment.description')}</Text>
        </Box>
        <Box gap="s16">
          {assessments.map((x, index) => (
            <AssessmentItem
              key={x.id}
              assessment={x}
              readonly={readonly}
              position={index + 1}
              onUpdate={onUpdate}
              loading={loading}
              accessCompetencies={accessCompetencies}
            />
          ))}
        </Box>
      </Box>
    </Box>
  )
}

export default observer(ReviewCompetencyAssessment)
